(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.refreshedtablelayoutblock = window.oneadvanced.refreshedtablelayoutblock || {};
    window.oneadvanced.refreshedtablelayoutblock.init = function () {
        //console.log("initializing refreshedtablelayoutblock js.......");

        var industryChallengesComponent = document.querySelector('.refreshedtablelayoutblock .industry-challenges')

        if (!industryChallengesComponent || !industryChallengesComponent.children.length) return

        var handleSetContentHeight = function() {
            var challengeHeights = []
            var solutionHeights = []

            var getChallengeContent = document.querySelectorAll('.challenge');
            var getSolutionContent = document.querySelectorAll('.solution');

            for (var child = 0; child < getChallengeContent.length; child++) {
                challengeHeights.push(getChallengeContent[child].offsetHeight);
            }
            for (var child = 0; child < getSolutionContent.length; child++) {
                solutionHeights.push(getSolutionContent[child].offsetHeight);
            }

            if (!challengeHeights.length || !solutionHeights.length) return
            if (window.innerWidth > 639) return

            for (var child = 0; child < getChallengeContent.length; child++) {
                getChallengeContent[child].style.height = `${Math.max(...challengeHeights)}px`;
            }
            for (var child = 0; child < getSolutionContent.length; child++) {
                getSolutionContent[child].style.height = `${Math.max(...solutionHeights)}px`;
            }
        }

        handleSetContentHeight();

        window.addEventListener("resize", function () {
            if (window.innerWidth < 640) {
                handleSetContentHeight()
            }
        });
    };

    window.oneadvanced.refreshedtablelayoutblock.hasLoaded = true;
})();